import React from "react";

import { Button, ParagraphMd, SectionHeading } from "@olist/design-system";
import { ChevronRightOutline } from "@olist/design-system-icons";

import { Wrapper } from "./styles";

interface IProductItem {
  image: JSX.Element;
  title: string;
  description: string;
  onClick: () => void;
}

export function ProductItem({
  description,
  image,
  onClick,
  title,
}: IProductItem) {
  return (
    <Wrapper
      flexDirection="column"
      flexGrow={1}
      flexShrink={1}
      flexBasis={400}
      maxWidth={600}
      gap={18}
    >
      {image}
      <SectionHeading>{title}</SectionHeading>
      <ParagraphMd style={{ minHeight: "72px" }}>{description}</ParagraphMd>
      <Button
        variation="secondary"
        iconRight={ChevronRightOutline}
        onClick={onClick}
        style={{ maxWidth: "152px" }}
      >
        Saiba mais
      </Button>
    </Wrapper>
  );
}
